module.exports = __webpack_public_path__ + "static/nag-me-2.c545b090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nag-me-2.jpg
// module id = 511
// module chunks = 43424109361899